import { useEffect, useMemo, useState } from 'react';
import { useGlobalContext } from 'context/GlobalContext';
import { Select } from 'components/partials/Fields/FormikSelect';
import { getIn, useFormikContext } from 'formik';
import { CANADA, USA } from 'helpers/constants/countries';

const StateSelect = ({
    name = 'state_id',
    label: labelPrepend = '',
    labelAppend = '',
    countryField = 'country_id',
    ...props
}) => {
    const { values } = useFormikContext();
    const { countries, getCountries } = useGlobalContext();
    const [states, setStates] = useState([]);
    const country_id = Number(getIn(values, countryField));
    const label = useMemo(() => {
        const lbl = labelPrepend ? labelPrepend + ' ' : '';
        return lbl + (country_id === CANADA.id ? 'Province' : 'State') + labelAppend;
    }, [country_id, labelAppend]);

    const getStates = async () => {
        if (!(country_id === USA.id || country_id === CANADA.id) || !countries) {
            return false;
        }
        if (countries.length === 0) await getCountries();

        const country = countries.find(c => c.country_id === country_id);
        const { states: countriesStates = [] } = country ?? [];

        setStates(countriesStates);
        return countriesStates;
    };

    useEffect(() => {
        getStates();
    }, [country_id, countries]);

    return (
        <Select
            formik
            label={label}
            name={name}
            addBlank={states}
            {...props}
        >
            {!states && (<option value="">Please Select a Country</option>)}
            {states.map(({ state_id, state_name }) => {
                return <option key={state_id} value={state_id}>{state_name}</option>;
            })}
        </Select>
    );
};

export default StateSelect;
